import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileUp, X, AlertCircle, CheckCircle2 } from 'lucide-react';

export const DocumentUploadSection = ({ existingDocuments, documents, docInputRef, onDocSelect, onRemoveNew, onRemoveExisting, t }) => {
  const totalDocs = (existingDocuments?.length || 0) + (documents?.length || 0);
  const hasDocs = totalDocs > 0;

  return (
    <Card
      className={`mb-6 ${hasDocs ? '' : 'border-orange-300 dark:border-orange-700/60'}`}
      data-testid="document-upload-card"
    >
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <FileUp className="h-5 w-5 text-orange-500" />
          {t('create.techSpec') || 'Technisches Datenblatt'} <span className="text-red-500">*</span>
          {hasDocs ? (
            <span className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-emerald-600 dark:text-emerald-400">
              <CheckCircle2 className="h-3.5 w-3.5" />
              {totalDocs} {totalDocs === 1 ? 'PDF' : 'PDFs'}
            </span>
          ) : (
            <span className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-orange-600 dark:text-orange-400">
              <AlertCircle className="h-3.5 w-3.5" />
              {t('create.techSpecRequired') || 'Pflichtfeld'}
            </span>
          )}
        </CardTitle>
        <p className="text-xs text-muted-foreground mt-1">
          {t('create.techSpecHint') ||
            'Mindestens ein technisches Datenblatt (PDF) ist erforderlich. Käufer benötigen die Spezifikation zur Materialprüfung.'}
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {existingDocuments.map((doc) => (
            <div key={doc.attachment_id} className="flex items-center gap-3 p-2 border rounded-lg group" data-testid={`existing-doc-${doc.attachment_id}`}>
              <FileUp className="h-5 w-5 text-orange-500 shrink-0" />
              <a href={doc.file_url} target="_blank" rel="noopener noreferrer" className="text-sm font-medium flex-1 truncate hover:text-orange-500">
                {doc.type?.replace(/_/g, ' ') || 'Document'}
              </a>
              <button onClick={() => onRemoveExisting(doc.attachment_id, 'doc')}
                className="text-red-500 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`remove-existing-doc-${doc.attachment_id}`}>
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}
          {documents.map((file, i) => (
            <div key={i} className="flex items-center gap-3 p-2 border rounded-lg group" data-testid={`new-doc-${i}`}>
              <FileUp className="h-5 w-5 text-orange-500 shrink-0" />
              <span className="text-sm font-medium flex-1 truncate">{file.name}</span>
              <span className="text-xs text-muted-foreground">{(file.size / 1024).toFixed(0)} KB</span>
              <button onClick={() => onRemoveNew(i)} className="text-red-500 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`remove-new-doc-${i}`}>
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}
          <button
            onClick={() => docInputRef.current?.click()}
            className={`w-full p-3 rounded-lg border-2 border-dashed flex items-center justify-center gap-2 transition-colors ${
              hasDocs
                ? 'border-slate-300 dark:border-slate-600 text-muted-foreground hover:border-orange-400 hover:text-orange-500'
                : 'border-orange-400 dark:border-orange-500/60 text-orange-600 hover:bg-orange-50 dark:hover:bg-orange-950/30'
            }`}
            data-testid="add-document-button"
          >
            <FileUp className="h-5 w-5" />
            <span className="text-sm font-medium">
              {hasDocs
                ? (t('create.addDocument') || 'Weiteres PDF hinzufügen')
                : (t('create.addTechSpec') || 'Technisches Datenblatt (PDF) hochladen')}
            </span>
          </button>
          <input ref={docInputRef} type="file" accept=".pdf,application/pdf" multiple className="hidden" onChange={onDocSelect} />
        </div>
      </CardContent>
    </Card>
  );
};
